import { render, staticRenderFns } from "./WillLanguageDialog.vue?vue&type=template&id=3bab0034&scoped=true"
import script from "./WillLanguageDialog.vue?vue&type=script&lang=js"
export * from "./WillLanguageDialog.vue?vue&type=script&lang=js"
import style0 from "./WillLanguageDialog.vue?vue&type=style&index=0&id=3bab0034&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bab0034",
  null
  
)

export default component.exports